import './style.less';
import { isEqual } from 'lodash';

export default type => {
  return ($scope, $q, $state, $stateParams, $uibModalInstance, CategoryClass, ApiClass, CoursesClass) => {
    'ngInject';

    $scope.createCOurse = () => {
      $scope.close();
      $state.go('app.author.courses', $stateParams);
    };

    $scope.onFilter = function(stCtrl) {
      const oldFiltered = $scope.filtered || [];
      const newFiltered = stCtrl.getFilteredCollection();
      if (!isEqual(oldFiltered, newFiltered)) $scope.selectAllCourses = false;
      $scope.filtered = stCtrl.getFilteredCollection();
    };

    $scope.selectAll = () => {
      $scope.filtered.forEach(course => (course.selected = $scope.selectAllCourses));
    };

    $scope.close = () => $uibModalInstance.dismiss('cancel');

    $scope.add = () => {
      const courses = $scope.courses.filter(({ selected }) => selected);
      $uibModalInstance.close(courses);
    };

    const deliveryMethods = { selfStudy: CoursesClass.delivery_methods, groupInternet: [2], groupLive: [1] }[type];

    $q.all([
      CategoryClass.loadCategories(),
      ApiClass.coursesGet(
        { courseType: false },
        {},
        {
          queryParams: {
            manage: true,
            filter: JSON.stringify({ deliveryMethods, activeOnly: true, basic: true })
          }
        }
      )
    ]).then(([categories, { data: { courses } }]) => {
      $scope.courses = courses;
      $scope.categoryDict = categories;
      $scope.loaded = true;
    });
  };
};



// WEBPACK FOOTER //
// ./src/app/modals/addCourses/index.js